module.exports = __webpack_public_path__ + "media/PAG64-06.117ecb5f.mp3";